import { UrgentActionsSummaryResponse } from '@nxsys/types/api/urgentActions';
import {
  BannerContainer,
  Categories,
  CountBadge,
  Divider,
  Headline,
  ReviewAll,
} from './index.styled';

interface Props {
  summary?: UrgentActionsSummaryResponse | null;
  onClick: () => void;
}

const UrgentActionsBanner = ({ summary, onClick }: Props) => {
  if (!summary || summary.total <= 0) return null;

  return (
    <BannerContainer onClick={onClick}>
      <CountBadge>{summary.total}</CountBadge>
      <Headline>submission issues need action today</Headline>
      {summary.categories.length > 0 && <Divider />}
      <Categories>
        {summary.categories.map((c) => (
          <span key={c.category}>{`${c.category} ${c.count}`}</span>
        ))}
      </Categories>
      <ReviewAll>Review all →</ReviewAll>
    </BannerContainer>
  );
};

export default UrgentActionsBanner;
